// Core
import React from "react"

// Styles
import styles from "./menuBtn.module.scss"

// Assets
import MenuIcon from "./assets/menu.png"
import CloseIcon from "./assets/close.png"

const MenuBtn = ({ open, event }) => {

  return (
    <button
      className={`button ${styles.menuBtn} ${open ? styles.open : styles.close}`}
      aria-label={"Open Menu"}
      onClick={() => event(!open)}
      >
      {
        open ? (
          <img src={CloseIcon} width="16" height="16" alt="Close Menu" />
        ) : (
          <img src={MenuIcon} width="20" height="15" alt="Open Menu" />
        )
      }
    </button>
  )
}

export default MenuBtn